<template>
    <div class="paymentSection">

        <!--Pay with Card-->
        <a href="#0" class="btn green activateStripeBtn" v-show="!stripeCardActivate && wallet === null && !useWallet" @click.prevent="activateStripeCard">Pay by Card</a>

        <div v-show="stripeCardActivate" class="stripeCardArea">
            <div v-show="!paySuccess">
                <div ref="card"></div>
                <a href="#0" v-show="!hidePayBtn" class="btn green payBtn" @click.prevent="purchase()">Pay {{ payAmountText | stripDecimals }} Now</a>
                <div v-show="hidePayBtn" class="loading small no-margin"></div>
                <p class="errorMsg" v-show="errorMsg !== ''">{{ errorMsg }}</p>
            </div>
            <div v-show="paySuccess">
                <p class="successMsg"><ion-icon name="checkmark-circle"></ion-icon> Payment Successfull!</p>
            </div>
        </div>

        <!--Pay with Wallet-->
        <div class="wallet" v-if="wallet !== null && !hidePayBtn && useWallet && !stripeCardActivate">
            <div class="card">
                <img src="../assets/img/cards/visa.png" height="25" alt="Visa" />
                <div class="card_wrapper">
                    <p class="card_type"><span>{{ wallet.card.brand }}</span>•••• {{ wallet.card.last4 }}</p>
                    <p class="card_exp">Expires {{ wallet.card.exp_month }} / {{ wallet.card.exp_year }}</p>
                </div>
            </div>
            <a href="#0" class="btn green payWithSavedCardBtn" @click.prevent="purchase()">Pay {{ payAmountText | stripDecimals }} with Saved Card</a>
            <a href="#0" class="btn green activateStripeBtn" v-show="!stripeCardActivate" @click.prevent="activateStripeCard">Use New Card</a>
            <p class="errorMsg" v-show="errorMsg !== ''">{{ errorMsg }}</p>
        </div>
        <div v-show="wallet !== null && hidePayBtn && useWallet && loading" class="loading small no-margin"></div>

        <!--Error messages-->
        <div v-if="!paySuccess && applePayAvailable" id="payment-request-button"></div>
        <p v-show="applePayErrorMsg !== '' && !paySuccess" class="errorMsg applePay">{{ applePayErrorMsg }}</p>
    </div>
</template>

<script>
    const fb = require('../firebaseConfig.js')
    let stripe = Stripe(`pk_live_IpUluxPVxWbd9w8xMRCcdIJa00IGxdts96`), // pk_test_wCqXZUbFLii8uDghTeoYjQ3A00yFtombvI
        elements = stripe.elements(),
        card = undefined,
        applePay = undefined;

    export default {
        data(){
            return{
                payLabel: 'OneMgl Membership Fee',
                payAmount: 100,
                payAmountText: '$1.00',
                stripeCardActivate: false,
                hidePayBtn: false,
                errorMsg: '',
                applePayAvailable: false,
                applePayErrorMsg: '',
                paySuccess: false,
                defaultPaymentMethod: null,
                savedPaymentMethod: null,
                useWallet: true,
                customerId: null,
                wallet: null,
                testMode: false,
                loading: false
            }
        },
        props: {
            'type': String,
            'eventId': String,
            'label': String,
            'amount': Number,
            'amountText': String
        },
        mounted: function(){

            let self = this

            if(this.type === 'event' || this.type === 'order'){
                self.payAmountText = this.amountText
                self.payAmount = (parseInt(this.amount) * 100)
                self.payLabel = this.label
            }

            if(window.location.host === 'localhost:8081'){
                self.testMode = true
            }

            /**
             * Pay By Card
             */

            let style = {
                base: {
                    border: '1px solid #D8D8D8',
                    borderRadius: '4px',
                    color: "#000"
                },
                invalid: {
                    border: '1px solid #cc1100',
                    color: '#cc1100'
                }
            }
            if(typeof(card) === 'undefined'){
                card = elements.create('card', style)
            }
            card.mount(this.$refs.card)

            
            /**
             * Apple Pay
             */

            // if(typeof(applePay) === 'undefined'){
            //     let paymentRequest = stripe.paymentRequest({
            //         country: 'CA',
            //         currency: 'cad',
            //         total: {
            //             label: self.payLabel,
            //             amount: self.payAmount
            //         },
            //         requestPayerName: true,
            //         requestPayerEmail: true
            //     })
            //     applePay = elements.create('paymentRequestButton', {
            //         paymentRequest: paymentRequest
            //     })
            //     paymentRequest.canMakePayment().then(function(result){
            //         if(result){
            //             self.applePayAvailable = true
            //             applePay.mount('#payment-request-button')
            //         }else{
            //             // document.getElementById('payment-request-button').style.display = 'none'
            //         }
            //     })
            //     paymentRequest.on('paymentmethod', function(ev) {
            //         self.purchaseApplePay(ev)
            //     })
            // }

            /**
             * Check for Saved User Payment Method & Customer Id
             */

            if(this.$store.state.userProfile !== null){

                console.log('User Payment Profile: ', this.$store.state.userProfile)

                // Payment Method Id
                if(typeof(this.$store.state.userProfile.membershipPayment) !== 'undefined'){
                    if(this.$store.state.userProfile.membershipPayment.payment_method !== null){

                        self.savedPaymentMethod = this.$store.state.userProfile.membershipPayment.payment_method

                        console.log('Using Saved Payment Method: ', self.savedPaymentMethod)
                    }
                }

                // Customer Id
                if(typeof(this.$store.state.userProfile.customerId) === 'undefined'){
                    self.getNewCustomerId()
                }else{
                    self.customerId = this.$store.state.userProfile.customerId
                    self.activateStripeCard()

                    console.log('Using existing customer id: ', self.customerId)
                }

                // Attach Payment Method if customer id and payment method exists
                if(self.savedPaymentMethod !== null && self.customerId !== null && self.useWallet){
                    if(typeof(this.$store.state.userProfile.wallet) === 'undefined'){
                        self.attachPaymentId()
                    }else{
                        self.wallet = this.$store.state.userProfile.wallet
                        self.stripeCardActivate = false

                        console.log('Using existing wallet: ', self.wallet)
                    }
                }
            }
        },
        computed: {
            currentUser(){
                return this.$store.state.currentUser
            },
            userProfile(){
                return this.$store.state.userProfile
            },
            isMember(){
                return this.$store.state.isMember
            }
        },
        methods: {
            activateStripeCard(){
                this.stripeCardActivate = true
            },
            resetPurchase(){
                this.hidePayBtn = false
                this.errorMsg = ''
            },
            attachPaymentId(){

                let self = this

                if(self.customerId !== null && self.savedPaymentMethod !== null){
                    
                    console.log('Attach payment id: ', self.customerId, self.savedPaymentMethod)

                    let userRef = fb.usersCollection.doc(this.$store.state.currentUser.uid)

                    self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/AttachPaymentMethod', {
                        paymentMethodId: self.savedPaymentMethod,
                        customerId: self.customerId
                    }).then(response => {
                        if(response.status === 200){

                            console.log('Attach payment method: ', response)

                            self.wallet = response.body.data

                            userRef.update({
                                wallet: response.body.data
                            }).then(function() {
                            
                                console.log("Customer id and payment method attached to user profile successfully!")

                            }).catch(function(error) {
                                console.error("Error updating document: ", error)
                            })
                        }
                    })
                    .catch((err) => {
                        console.log('Error attaching payment method to customer! ', err)
                    })
                }
            },
            getNewCustomerId(){

                let self = this

                let customerOptions = {
                    email: this.$store.state.currentUser.email
                }
                let userRef = fb.usersCollection.doc(this.$store.state.currentUser.uid)

                console.log('Creating new customer id with email: ', this.$store.state.currentUser.email)

                self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/CreateStripeCustomer', customerOptions).then(response => {
                    
                    console.log('Create stripe customer: ', response)

                    if(response.status === 200){

                        self.customerId = response.body.id
                        
                        userRef.update({
                            customerId: self.customerId
                        }).then(function() {
                        
                            console.log("Customer id saved to user profile successfully!")

                            self.activateStripeCard()
                            self.$store.dispatch('fetchUserProfile')
                        
                        }).catch(function(error) {
                            console.error("Error updating document: ", error)
                        })
                    }
                })
                .catch((err) => {
                    console.log('Error creating new stripe customer! ', err)
                })
            },
            purchase(){

                let self = this

                self.loading = true
                self.hidePayBtn = true
                self.errorMsg = ''

                if(this.$store.state.currentUser !== null){
                    if(this.$store.state.currentUser.uid === 'MxARUElzBNhyyJbdwYkOL55vxxJ2'){
                        self.payAmount = 100
                        alert('Your are an origanizer you will pay only: $'+ self.payAmount)
                    }
                }

                let intentOptions = {
                    amount: self.payAmount,
                    email: this.$store.state.currentUser.email,
                    currency: 'CAD',
                    description: self.payLabel
                }
                if(self.customerId !== null){
                    intentOptions.customerId = self.customerId
                }
                if(self.wallet !== null && self.useWallet){
                    if(self.wallet.id !== null){
                        
                        console.log('Purchase with saved card!')

                        intentOptions.paymentMethodId = self.wallet.id
                    }
                }
                if(self.testMode){
                    console.log('Stripe using test mode! ', self.payAmount)
                    intentOptions.test = true
                }

                self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/CheckoutSessionDynamic', intentOptions).then(response => {
                    if(response.status === 200){

                        console.log('Stripe client secret: ', response)
                        self.processPayment(response.body)

                    }else{
                        console.log('Stripe client secret error: ', response)
                        self.hidePayBtn = false
                    }
                }).catch(response => {
                    console.log('Stripe token error: ', response)

                    self.hidePayBtn = false

                    if(response.status === 500){
                        self.errorMsg = response.body.message
                    }
                })
            },
            processPayment(clientSecret){

                let self = this

                let options = {
                    payment_method: {
                        card: card,
                        billing_details: {
                            name: this.currentUser.displayName,
                            email: this.currentUser.email
                        }
                    }
                }

                if(self.wallet !== null && self.useWallet){
                    if(self.wallet.id !== null){
                        
                        console.log('Confirm payment with saved card!')

                        options = {
                            payment_method: self.wallet.id
                        }
                    }
                }

                stripe.confirmCardPayment(clientSecret, options).then(function(result) {
                    if (result.error) {
                        
                        self.hidePayBtn = false
                        self.errorMsg = result.error.message

                        console.log('Stripe pay error: ', result.error.message)
                    
                    } else {
                        if (result.paymentIntent.status === 'succeeded') {
                            
                            self.hidePayBtn = true
                            self.errorMsg = ''
                            self.paySuccess = true
                            self.defaultPaymentMethod = 'card'
                            self.loading = false
                            
                            console.log('Payment successfull!')
                            console.log('Stripe payment success: ', result)

                            self.saveTransaction(result.paymentIntent) 
                        }
                    }
                })
            },
            purchaseApplePay(ev){

                let self = this

                let intentOptions = {
                    amount: self.payAmount,
                    email: this.$store.state.currentUser.email,
                    currency: 'CAD',
                    description: self.payLabel
                }
                if(self.customerId !== null){
                    intentOptions.customerId = self.customerId
                }
                // if(self.savedPaymentMethod !== null){
                //     intentOptions += '&paymentMethodId=' + self.savedPaymentMethod
                // }
                if(self.testMode){
                    intentOptions.test = true
                }

                self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/CheckoutSessionDynamic', intentOptions).then(response => {
                    if(response.status === 200){

                        console.log('Stripe client secret: ', response)
                        
                        let clientSecret = response.body
                        
                        stripe.confirmCardPayment(clientSecret, {
                            payment_method: ev.paymentMethod.id
                        },{
                            handleActions: false
                        }).then(function(confirmResult) {
                            if (confirmResult.error) {
                                
                                ev.complete('fail')
                                self.hidePayBtn = false
                                self.applePayErrorMsg = confirmResult.error.message

                                console.log('Stripe apple pay error1: ', confirmResult.error.message)

                            } else {
                                ev.complete('success')
                                stripe.confirmCardPayment(clientSecret).then(function(result) {
                                    if (result.error) {
                                        
                                        self.hidePayBtn = false
                                        self.applePayErrorMsg = result.error.message

                                        console.log('Stripe apple pay error2: ', result.error.message)

                                    } else {
                                    
                                        self.errorMsg = ''
                                        self.applePayErrorMsg = ''
                                        self.hidePayBtn = true
                                        self.paySuccess = true
                                        self.defaultPaymentMethod = 'applePay'
                                        
                                        console.log('Stripe apple pay success: ', result)

                                        self.saveTransaction(result.paymentIntent)
                                    }
                                })
                            }
                        })

                    }else{
                        console.log('Stripe client secret error: ', response)
                        self.hidePayBtn = false
                    }
                }).catch((err) => {
                    console.log('Stripe token error: '+ err.message)
                    self.hidePayBtn = false
                    self.applePayErrorMsg = err.message
                })
            },
            upgradeMember(stripeResponse){

                console.log('Upgrade member uid: ', this.currentUser.uid)

                let self = this
                let userRef = fb.usersCollection.doc(this.currentUser.uid)

                userRef.update({
                    isMember: true,
                    membershipPayment: stripeResponse,
                    defaultPaymentMethod: self.defaultPaymentMethod,
                    timestamp: fb.firebase.firestore.FieldValue.serverTimestamp()
                }).then(function() {
                
                    console.log("Member upgraded!")

                    self.$store.dispatch('fetchUserProfile')
                    // self.$router.push('/account')
                    
                    self.$emit('paymentSuccess', stripeResponse.id)
                
                }).catch(function(error) {
                    console.error("Error updating document: ", error)
                })
            },
            saveTransaction(stripeResponse){

                let self = this
                let userRef = fb.usersCollection.doc(this.$store.state.currentUser.uid).collection('transactions').doc(stripeResponse.id)
                let transactionData = stripeResponse

                transactionData.type = self.type
                if(self.type === 'event'){
                    transactionData.eventId = self.eventId
                }
                transactionData.payAmount = self.payAmount
                transactionData.payAmountText = self.payAmountText
                transactionData.payLabel = self.payLabel

                userRef.set(transactionData).then(function(){

                    console.log('User transaction saved to profile!')
                    self.$store.dispatch('fetchUserProfile')

                    if(self.type === 'membership'){
                        self.upgradeMember(stripeResponse)
                    }else{
                        self.$emit('paymentSuccess', stripeResponse.id)
                    }

                }).catch(err => {
                    console.log('Error saving transaction to profile')
                })
            },
            stripCurrency(val){
                return val.replace(',','').replace('$','').replace('.','')
            }
        },
        filters: {
            getFirstName(value){
                if(!value) return ''
                return value.split(' ').slice(0, -1).join(' ')
            },
            stripDecimals(value){
                if(!value) return ''
                return value.replace('.00','')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Payment.vue